// extracted by mini-css-extract-plugin
module.exports =  {"description":"gGABJbykmGXyfL4t9cWQ","alert":"quC4vbU4vAMkAmVQ983O"};